import { useMemo } from 'react';
import type { ColumnsType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';
import type { AssignmentConflictResponseDto } from '@evimo/client/models';
import type { StepAssignableAssetRow } from '../types';

export function useStepAssetsColumns() {
  const { t } = useTranslation('maintenance');

  const assetColumns: ColumnsType<StepAssignableAssetRow> = useMemo(
    () => [
      {
        title: t('wizard.assets.conflicts.assetName'),
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: t('wizard.assets.conflicts.serial'),
        dataIndex: 'serialNumber',
        key: 'serialNumber',
      },
      {
        title: t('wizard.assets.conflicts.zone'),
        dataIndex: 'zoneName',
        key: 'zoneName',
      },
      {
        title: t('wizard.assets.conflicts.site'),
        dataIndex: 'siteName',
        key: 'siteName',
      },
    ],
    [t],
  );

  const conflictColumns: ColumnsType<AssignmentConflictResponseDto> = useMemo(
    () => [
      {
        title: t('wizard.assets.conflicts.assetName'),
        dataIndex: 'assetName',
        key: 'assetName',
      },
      {
        title: t('wizard.assets.conflicts.serial'),
        dataIndex: 'serialNumber',
        key: 'serialNumber',
      },
      {
        title: t('wizard.assets.conflicts.zone'),
        dataIndex: 'zoneName',
        key: 'zoneName',
      },
      {
        title: t('wizard.assets.conflicts.currentPlan'),
        dataIndex: 'conflictingPlanName',
        key: 'conflictingPlanName',
      },
      {
        title: t('wizard.assets.conflicts.since'),
        dataIndex: 'since',
        key: 'since',
        render: (val: Date | string) => new Date(val).toLocaleDateString(),
      },
    ],
    [t],
  );

  return { assetColumns, conflictColumns };
}
